// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.basic-single {
  margin-top: 15px !important;
  width: 350px !important;
  margin-bottom: 15px !important;
}

.chart-wrapper {
  padding: 2%;
  display: inline-block;
}

.sub.chart-wrapper {
  width: 29%;
  height: 300px;
}

.type-legend-container {
  font-size: 18px;
  /* font-weight: 600; */
  text-align: left;
  padding: 30px;
}

.type-summary-chart-container {
  font-size: 18px;
  /* font-weight: 600; */
  text-align: left;
  padding: 5px 5px 5px 15px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px;
  max-width: 100%;
  overflow: hidden;
}

.type-summary-chart-container > * {
  flex: 1 1;
  /* min-width: 300px; */
  /* max-width: 48%; */
  padding: 15px;
  background: #fff;
  border-radius: 10px;
  /* box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1); */
  box-sizing: border-box;
  overflow-x: scroll;
}

.type-summary-chart-container table {
  width: 100%;
  max-width: 100%;
  border-collapse: collapse;
  table-layout: auto;
}

.dashboard-grid-table .rdt_TableBody {
    overflow: scroll;
    height: auto !important;
    padding: 0px !important; 
    padding-right: 0px !important; 
}

.type-summary-chart-container td {
  white-space: normal !important;
  text-overflow: ellipsis;
  word-wrap: break-word !important;
}

@media screen and (max-width: 768px) {
  .type-summary-chart-container {
    flex-direction: column;
  }

  .type-summary-chart-container > * {
    max-width: 100%;
  }
}

.summary-chart-chart-title{
  padding:  0.9375rem 0.9375rem 0 0.9375rem;
  font-size: 18px;
  font-weight: 500;
  text-align: left;
  border-top-left-radius: 15px; 
  border-top-right-radius: 15px; 
}

.main.chart-wrapper {
  width: 96%;
  height: 400px;
}

.select__option .select__option--is-focused .select__option--is-selected {
  background-color: #e3e9f4 !important;
  color: black !important;
  border-radius: 14px !important;
}

.css-tr4s17-option {
  background-color: #e3e9f4 !important;
  color: black !important;
  border-radius: 14px !important;
}

.css-d7l1ni-option :hover {
  background-color: #e3e9f4 !important;
  color: black !important;
  border-radius: 14px !important;
}

.select__menu {
  padding: 12px !important;
}

.select__indicator-separator{
  background-color: white !important;
}

.select__control {
  border: 2px solid #e3e9f4 !important;
  border-radius: 15px !important;
}

@media (max-width: 700px) {
  .sub.chart-wrapper {
    width: 96%;
  }
}

.grid-container {
  display: grid;
  gap: 20px 20px;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: auto auto auto;
  padding: 10px;
  background-image: linear-gradient(
    var(--primary-opactiy-10),
    var(--primary-opactiy-50)
  );
}

.th-container {
  word-wrap: break-word !important;
  white-space: normal !important;
  max-width: 160px !important;
}

.table-custom-dashboard-closed {
  background: white;
  height: 89vh;
  border-radius: 12px;
  display: grid;
  grid-template-columns: 1fr 60px;
}

.slider-text-field input[type="text"],
input[type="email"],
input[type="password"],
input[type="date"],
input[type="number"] {
  height: 39px !important;
  box-sizing: border-box !important;
  font-size: 14px;
  font-weight: 600;
  padding: 7px !important;
  outline: none;
  margin-bottom: 0px !important ;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* For Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.table-custom-dashboard {
  background: white;
  height: 89vh;
  border-radius: 12px;
  display: grid;
  grid-template-columns: 1fr 368px;
}

.pinned-dropdown {
  pointer-events: none; 
  opacity: 0.6; 
  cursor: not-allowed; 
}

.pinned-dropdown .dropdown-container {
  color: #999; 
}

.pinned-dropdown .multiSelect {
  background-color: #f5f5f5; 
}


#popover-basic {
  position: absolute;
  inset: 0px auto auto 0px;
  transform: translate(766.25px, 292.5px);
  /* position: absolute; */
  /* right: 0; */
  /* top: 22px; */
  background-color: #ffffff !important;
  padding: 0px 30px !important;
  border: 1px solid #e3e9f4 !important;
  z-index: 9 !important;
  padding: 13px 15px !important;
  text-align: center !important;
  border-radius: 14px !important;
  box-shadow: 10px 14px 74px 0px var(--primary-opactiy-10) !important;
}

.chart-type-options {
  padding: 0px 15px;
}

.chart-type-options:hover {
  background-color: var(--foundation-neutral-neutral-400, #e3e9f4);
  padding: 0px 15px;
  border-radius: 15px;
}

.grid-item {
  /* padding: 20px; */
  font-size: 30px;
  /* z-index: 9999999; */
  border-radius: 14px;
  /* border: 1px solid var(--foundation-neutral-neutral-400, #E3E9F4); */
  background: #fff;
  /* background: black; */
  /* box-shadow: 19px 43px 82px 76px var(--primary-opactiy-10); */
}

.custom-input-filter input[type="number"] input[type="text"] {
  border-radius: 12px;
  border: 2px solid #e3e9f4 !important;
  padding: 16px 24px !important;
  outline: none;
  margin-bottom: 15px;
}

.custom-input-filter input[type="text"] {
  border-radius: 12px;
  border: 2px solid #e3e9f4 !important;
  padding: 16px 24px !important;
  outline: none;
  margin-bottom: 15px;
}

.card-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  padding: 20px;
}

.number-card {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: white;
}

.loading {
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* TableChart.css */
.table-chart-container {
  font-size: 14px;
  overflow-x: auto;
  max-height: none;
  overflow-y: hidden;
  position: relative;
}

.table-chart {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
}

.custom-table-header{
  display: flex;
  justify-content: space-between;
  padding:  0.9375rem;
  font-size: 18px;
  font-weight: 500;
}

/* Dropdown container */
.custom-dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown button styling */
.dropdown-toggle {
  padding: 5px 10px;
  width: 100px;
  background-color: #1e88e5;
  color: white;
  border: none;
  cursor: pointer;
  font-size: 14px;
  border-radius: 4px;
}

.dropdown-toggle-column {
  padding: 5px 10px;
    background-color: #1e88e5;
    color: white;
    border: none;
    cursor: pointer;
    font-size: 14px;
    border-radius: 4px;
}

.solid-tooltip {
  opacity: 1 !important;
  background-color: white !important;
  z-index: 99999;
}
.solid-tooltip-arrow {
  background-color: white !important;
}

.recharts-legend-wrapper{
  right: 45px !important;
}

.legend-item{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    /* max-width: 350px; */
}

.recharts-default-legend {
  /* text-align: left !important;
  margin: 25px !important; */
}

/* 
.legend-span {
    display: inline-block;
    max-width: 100px; 
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
} */
/* Dropdown menu styling */
.dropdown-menu {
  position: absolute;
  top: 100%;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px !important;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 100px;
}

/* Dropdown item styling */
.dropdown-menu div {
  padding: 2px;
  cursor: pointer;
  font-size: 14px;
}

/* Hover effect on dropdown items */
.dropdown-menu div:hover {
  background-color: #f0f0f0;
}


/* .filter-icon {
font-size: 16px;
padding-left: 10px;
cursor: pointer;
}

.dropdown-menus {
width: 100px;
display: none;
background-color: white;
border: 1px solid #ddd;
box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
z-index: 9;
top: 100%;
font-weight: 500;
left: 0;
padding-left: 4px;
}

.filter-icon:hover .dropdown-menu {
display: block;
}

.dropdown-menu button {
display: block;
padding: 5px 10px;
width: 100%;
text-align: left;
border: none;
background-color: #f9f9f9;
cursor: pointer;
}

.dropdown-menu button:hover {
background-color: #f1f1f1;
} */

.sortable {
  position: relative;
  font-size: 13px;
}

.pagination-controls {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 5px;
  margin-right: 10px;
}

.pagination-controls button {
  background-color: transparent;
  /* color: #59ddd3;  */
  border: none;
  padding: 0 5px;
  margin: 0 5px;
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
  transition: color 0.3s ease, transform 0.2s ease, background-color 0.3s ease;
  border-radius: 50%;
}

.pagination-controls .page-number {
  font-size: 18px;
}

.pagination-controls button:disabled {
  color: #cccccc;
}

.pagination-controls button:hover:not(:disabled) {
  /* color: #0056b3;  */
  color: #b8b8b8;
  /* transform: scale(1);  */
  /* padding: 5px;  */
}

.pagination-controls button:active:not(:disabled) {
  /* color: #004080;  */
  color: #b8b8b8;
  /* transform: scale(1);  */
}

.chart-header {
  position: relative;
  text-align: center;
  margin-bottom: 2px;
}

.export-csv-button {
  position: absolute;
  right: 0; /* Align to the right side */
  top: 50%;
  transform: translateY(-50%); /* Center vertically */
  background-color: transparent;
  border: none;
  cursor: pointer;
}

.export-csv-button i {
  margin-right: 5px;
  font-size: 14px;
}


/*Map */
.custom-map-tooltip {
  position: absolute;
  text-align: center;
  color: white;
  width: auto;
  height: auto;
  padding: 5px;
  font: 12px sans-serif;
  background: black !important;
  border: 1px solid black !important;
  border-radius: 8px;
  pointer-events: none;
}

.custom-triangle-marker div {
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 20px solid red; /* Default color for the triangle */
  position: relative;
  top: -10px; /* Adjusts the triangle position */
}

.filter-content {
  /* z-index: 1000000000 !important; */
  /* top: 65px; */
  /* width: 13rem; */
  right: 19px;
  height: 100%;
  width: 24rem;
  background-color: white;
  box-shadow: -5px 0px 7px 0px rgba(223, 224, 225, 0.2);
  transform: translateX(100%);
  transition: transform 0.3s ease-in-out;
  height: 83vh;
  position: fixed;
}

.DarkTheme .filter-content {
  background-color: var(
    --foundation-neutral-dark-theme-neutral-dark-theme-500,
    #494b4b
  );
}

.DarkTheme .dark-heading {
  color: black !important;
}

.filter-content.open {
  transform: translateX(0);
}

.button-toggle-filter {
  margin-left: -2rem;
  position: absolute;
  z-index: 1000000000000;
  margin-top: -2rem;
}

.content-view-filters {
  height: 100vh;
  padding: 20px;
  overflow-y: auto;
  overflow-x: hidden;
}

.filter-popup {
  position: absolute;
  width: 100%;
  top: 10%;
  left: 0;
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.filter-popup-content {
  z-index: 1000;
}

.overlay-filter-popup {
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;
}

.disabled-filter-content {
  pointer-events: none;
  opacity: 0.5;
}

.filter-top-container-bottom-border {
  margin-top: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid var(--primary);
  box-shadow: 0 4px 2px -2px var(--secondary-100);
}

/* Select control (dropdown input) */
.custom-select__control {
  border: 2px solid var(--primary) !important;
  box-shadow: none !important;
  border-radius: 12px !important;
}

.custom-select__control:hover {
  border-color: #888;
}

/* Select menu (dropdown list) */
.custom-select__menu {
  border: 1px solid var(--primary);
  width: 200px; /* Adjust if needed */
  border-radius: 12px !important;
  font-size: 14px !important;
}

/* Highlight on hover */
.custom-select__option--is-focused {
  background-color: #f0f0f0;
}

/* Selected option */
.custom-select__option--is-selected {
  background-color: #ccc;
}

/* Apply ellipsis to the options that exceed the width */
.custom-select__option {
  white-space: nowrap; 
  overflow: hidden; 
  text-overflow: ellipsis; 
  max-width: 100%; 
  position: relative; 
}

/* Show full option name in a tooltip on hover */
.custom-select__option:hover::after {
  content: attr(data-tooltip); 
  position: absolute;
  left: 100%; 
  top: 0;
  white-space: nowrap;
  background-color: #333;
  color: #fff;
  padding: 5px;
  border-radius: 3px;
  z-index: 10;
  font-size: 12px;
  display: inline-block;
  opacity: 1;
  visibility: visible;
}

/* Make sure the tooltip is hidden by default */
.custom-select__option::after {
  content: "";
  display: none;
  opacity: 0;
  visibility: hidden;
}

.custom-option {
  white-space: nowrap; 
  overflow: hidden; 
  text-overflow: ellipsis; 
  max-width: 100%; 
  display: block; 
}

.overlay-filter-save-popup {
  position: fixed;
  top: 0;
  z-index: 20000000000 !important;
  bottom: 0;
  left: 0;
  right: 0;
  background: var(--foundation-neutral-neutral-900, #5c6065c1);
  width: 100%;
  height: 107%;
  display: flex;
  justify-content: center;
  .taskPopUp,
  .memberPopup,
  .modalPopup {
    margin-top: 80px;
    background: white;
    overflow-x: hidden;
    max-height: -moz-fit-content;
    max-height: fit-content;
    min-width: 95%;
    &.h-auto {
      height: auto !important;
      min-height: auto;
    }
    .scrollable {
      max-height: 65vh;
      overflow-y: auto;
      scroll-behavior: smooth;
      height: -webkit-fill-available;
    }
    .title {
      overflow: hidden;
      color: var(--text-high-emphasis, #090826);
      text-overflow: ellipsis;

      /* Typography/Heading 3/Bold */
      font-family: Inter;
      font-size: 1.8rem;
      font-style: normal;
      font-weight: 600;
      line-height: 120%; /* 42px */
    }
    .title-text-small-color {
      color: var(--text-high-emphasis, #090826);
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/kz-dashboards/css/dashboard.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,iDAAiD;EACjD,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sCAAsC;EACtC,kCAAkC;EAClC,aAAa;EACb;;;GAGC;AACH;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,+BAA+B;AACjC;;AAEA;;;;;EAKE,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,8BAA8B;AAChC;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,uCAAuC;EACvC,wBAAwB;EACxB,cAAc;EACd,eAAe;EACf,oCAAoC;EACpC,4BAA4B;EAC5B,oCAAoC;EACpC,qBAAqB;EACrB,6BAA6B;EAC7B,6BAA6B;EAC7B,8BAA8B;EAC9B,mEAAmE;AACrE;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gEAAgE;EAChE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,sEAAsE;EACtE,gBAAgB;EAChB,uBAAuB;EACvB,+DAA+D;AACjE;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,MAAM;EACN,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;IACf,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,cAAc;AAChB;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;EACE;4BAC0B;AAC5B;;AAEA;;;;;;;GAOG;AACH,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;AAC3B;;;AAGA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAmCG;;AAEH;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,4EAA4E;EAC5E,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ,EAAE,4BAA4B;EACtC,QAAQ;EACR,2BAA2B,EAAE,sBAAsB;EACnD,6BAA6B;EAC7B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;;AAGA,OAAO;AACP;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;EAC5B,kCAAkC;EAClC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,6BAA6B,EAAE,mCAAmC;EAClE,kBAAkB;EAClB,UAAU,EAAE,kCAAkC;AAChD;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,qDAAqD;EACrD,2BAA2B;EAC3B,sCAAsC;EACtC,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;;;GAGC;AACH;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,OAAO;EACP,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA,oCAAoC;AACpC;EACE,2CAA2C;EAC3C,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,gCAAgC;EAChC,YAAY,EAAE,qBAAqB;EACnC,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,sBAAsB;AACxB;;AAEA,wDAAwD;AACxD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,UAAU;EACV,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,aAAa;EACb,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,+BAA+B;EAC/B,SAAS;EACT,OAAO;EACP,QAAQ;EACR,4DAA4D;EAC5D,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB;;;IAGE,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,4BAAuB;IAAvB,uBAAuB;IACvB,cAAc;IACd;MACE,uBAAuB;MACvB,gBAAgB;IAClB;IACA;MACE,gBAAgB;MAChB,gBAAgB;MAChB,uBAAuB;MACvB,8BAA8B;IAChC;IACA;MACE,gBAAgB;MAChB,yCAAyC;MACzC,uBAAuB;;MAEvB,8BAA8B;MAC9B,kBAAkB;MAClB,iBAAiB;MACjB,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB,EAAE,SAAS;IAC9B;IACA;MACE,yCAAyC;IAC3C;EACF;AACF","sourcesContent":[".basic-single {\n  margin-top: 15px !important;\n  width: 350px !important;\n  margin-bottom: 15px !important;\n}\n\n.chart-wrapper {\n  padding: 2%;\n  display: inline-block;\n}\n\n.sub.chart-wrapper {\n  width: 29%;\n  height: 300px;\n}\n\n.type-legend-container {\n  font-size: 18px;\n  /* font-weight: 600; */\n  text-align: left;\n  padding: 30px;\n}\n\n.type-summary-chart-container {\n  font-size: 18px;\n  /* font-weight: 600; */\n  text-align: left;\n  padding: 5px 5px 5px 15px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 10px;\n  max-width: 100%;\n  overflow: hidden;\n}\n\n.type-summary-chart-container > * {\n  flex: 1 1;\n  /* min-width: 300px; */\n  /* max-width: 48%; */\n  padding: 15px;\n  background: #fff;\n  border-radius: 10px;\n  /* box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1); */\n  box-sizing: border-box;\n  overflow-x: scroll;\n}\n\n.type-summary-chart-container table {\n  width: 100%;\n  max-width: 100%;\n  border-collapse: collapse;\n  table-layout: auto;\n}\n\n.dashboard-grid-table .rdt_TableBody {\n    overflow: scroll;\n    height: auto !important;\n    padding: 0px !important; \n    padding-right: 0px !important; \n}\n\n.type-summary-chart-container td {\n  white-space: normal !important;\n  text-overflow: ellipsis;\n  word-wrap: break-word !important;\n}\n\n@media screen and (max-width: 768px) {\n  .type-summary-chart-container {\n    flex-direction: column;\n  }\n\n  .type-summary-chart-container > * {\n    max-width: 100%;\n  }\n}\n\n.summary-chart-chart-title{\n  padding:  0.9375rem 0.9375rem 0 0.9375rem;\n  font-size: 18px;\n  font-weight: 500;\n  text-align: left;\n  border-top-left-radius: 15px; \n  border-top-right-radius: 15px; \n}\n\n.main.chart-wrapper {\n  width: 96%;\n  height: 400px;\n}\n\n.select__option .select__option--is-focused .select__option--is-selected {\n  background-color: #e3e9f4 !important;\n  color: black !important;\n  border-radius: 14px !important;\n}\n\n.css-tr4s17-option {\n  background-color: #e3e9f4 !important;\n  color: black !important;\n  border-radius: 14px !important;\n}\n\n.css-d7l1ni-option :hover {\n  background-color: #e3e9f4 !important;\n  color: black !important;\n  border-radius: 14px !important;\n}\n\n.select__menu {\n  padding: 12px !important;\n}\n\n.select__indicator-separator{\n  background-color: white !important;\n}\n\n.select__control {\n  border: 2px solid #e3e9f4 !important;\n  border-radius: 15px !important;\n}\n\n@media (max-width: 700px) {\n  .sub.chart-wrapper {\n    width: 96%;\n  }\n}\n\n.grid-container {\n  display: grid;\n  gap: 20px 20px;\n  grid-template-columns: repeat(12, 1fr);\n  grid-template-rows: auto auto auto;\n  padding: 10px;\n  background-image: linear-gradient(\n    var(--primary-opactiy-10),\n    var(--primary-opactiy-50)\n  );\n}\n\n.th-container {\n  word-wrap: break-word !important;\n  white-space: normal !important;\n  max-width: 160px !important;\n}\n\n.table-custom-dashboard-closed {\n  background: white;\n  height: 89vh;\n  border-radius: 12px;\n  display: grid;\n  grid-template-columns: 1fr 60px;\n}\n\n.slider-text-field input[type=\"text\"],\ninput[type=\"email\"],\ninput[type=\"password\"],\ninput[type=\"date\"],\ninput[type=\"number\"] {\n  height: 39px !important;\n  box-sizing: border-box !important;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 7px !important;\n  outline: none;\n  margin-bottom: 0px !important ;\n}\n\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* For Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.table-custom-dashboard {\n  background: white;\n  height: 89vh;\n  border-radius: 12px;\n  display: grid;\n  grid-template-columns: 1fr 368px;\n}\n\n.pinned-dropdown {\n  pointer-events: none; \n  opacity: 0.6; \n  cursor: not-allowed; \n}\n\n.pinned-dropdown .dropdown-container {\n  color: #999; \n}\n\n.pinned-dropdown .multiSelect {\n  background-color: #f5f5f5; \n}\n\n\n#popover-basic {\n  position: absolute;\n  inset: 0px auto auto 0px;\n  transform: translate(766.25px, 292.5px);\n  /* position: absolute; */\n  /* right: 0; */\n  /* top: 22px; */\n  background-color: #ffffff !important;\n  padding: 0px 30px !important;\n  border: 1px solid #e3e9f4 !important;\n  z-index: 9 !important;\n  padding: 13px 15px !important;\n  text-align: center !important;\n  border-radius: 14px !important;\n  box-shadow: 10px 14px 74px 0px var(--primary-opactiy-10) !important;\n}\n\n.chart-type-options {\n  padding: 0px 15px;\n}\n\n.chart-type-options:hover {\n  background-color: var(--foundation-neutral-neutral-400, #e3e9f4);\n  padding: 0px 15px;\n  border-radius: 15px;\n}\n\n.grid-item {\n  /* padding: 20px; */\n  font-size: 30px;\n  /* z-index: 9999999; */\n  border-radius: 14px;\n  /* border: 1px solid var(--foundation-neutral-neutral-400, #E3E9F4); */\n  background: #fff;\n  /* background: black; */\n  /* box-shadow: 19px 43px 82px 76px var(--primary-opactiy-10); */\n}\n\n.custom-input-filter input[type=\"number\"] input[type=\"text\"] {\n  border-radius: 12px;\n  border: 2px solid #e3e9f4 !important;\n  padding: 16px 24px !important;\n  outline: none;\n  margin-bottom: 15px;\n}\n\n.custom-input-filter input[type=\"text\"] {\n  border-radius: 12px;\n  border: 2px solid #e3e9f4 !important;\n  padding: 16px 24px !important;\n  outline: none;\n  margin-bottom: 15px;\n}\n\n.card-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  justify-content: center;\n  padding: 20px;\n}\n\n.number-card {\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: white;\n}\n\n.loading {\n  left: 0;\n  top: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n/* TableChart.css */\n.table-chart-container {\n  font-size: 14px;\n  overflow-x: auto;\n  max-height: none;\n  overflow-y: hidden;\n  position: relative;\n}\n\n.table-chart {\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\n.custom-table-header{\n  display: flex;\n  justify-content: space-between;\n  padding:  0.9375rem;\n  font-size: 18px;\n  font-weight: 500;\n}\n\n/* Dropdown container */\n.custom-dropdown {\n  position: relative;\n  display: inline-block;\n}\n\n/* Dropdown button styling */\n.dropdown-toggle {\n  padding: 5px 10px;\n  width: 100px;\n  background-color: #1e88e5;\n  color: white;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  border-radius: 4px;\n}\n\n.dropdown-toggle-column {\n  padding: 5px 10px;\n    background-color: #1e88e5;\n    color: white;\n    border: none;\n    cursor: pointer;\n    font-size: 14px;\n    border-radius: 4px;\n}\n\n.solid-tooltip {\n  opacity: 1 !important;\n  background-color: white !important;\n  z-index: 99999;\n}\n.solid-tooltip-arrow {\n  background-color: white !important;\n}\n\n.recharts-legend-wrapper{\n  right: 45px !important;\n}\n\n.legend-item{\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    /* max-width: 350px; */\n}\n\n.recharts-default-legend {\n  /* text-align: left !important;\n  margin: 25px !important; */\n}\n\n/* \n.legend-span {\n    display: inline-block;\n    max-width: 100px; \n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n} */\n/* Dropdown menu styling */\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  background-color: white;\n  border: 1px solid #ccc;\n  border-radius: 4px !important;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  min-width: 100px;\n}\n\n/* Dropdown item styling */\n.dropdown-menu div {\n  padding: 2px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n/* Hover effect on dropdown items */\n.dropdown-menu div:hover {\n  background-color: #f0f0f0;\n}\n\n\n/* .filter-icon {\nfont-size: 16px;\npadding-left: 10px;\ncursor: pointer;\n}\n\n.dropdown-menus {\nwidth: 100px;\ndisplay: none;\nbackground-color: white;\nborder: 1px solid #ddd;\nbox-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\nz-index: 9;\ntop: 100%;\nfont-weight: 500;\nleft: 0;\npadding-left: 4px;\n}\n\n.filter-icon:hover .dropdown-menu {\ndisplay: block;\n}\n\n.dropdown-menu button {\ndisplay: block;\npadding: 5px 10px;\nwidth: 100%;\ntext-align: left;\nborder: none;\nbackground-color: #f9f9f9;\ncursor: pointer;\n}\n\n.dropdown-menu button:hover {\nbackground-color: #f1f1f1;\n} */\n\n.sortable {\n  position: relative;\n  font-size: 13px;\n}\n\n.pagination-controls {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-top: 5px;\n  margin-right: 10px;\n}\n\n.pagination-controls button {\n  background-color: transparent;\n  /* color: #59ddd3;  */\n  border: none;\n  padding: 0 5px;\n  margin: 0 5px;\n  font-size: 24px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: color 0.3s ease, transform 0.2s ease, background-color 0.3s ease;\n  border-radius: 50%;\n}\n\n.pagination-controls .page-number {\n  font-size: 18px;\n}\n\n.pagination-controls button:disabled {\n  color: #cccccc;\n}\n\n.pagination-controls button:hover:not(:disabled) {\n  /* color: #0056b3;  */\n  color: #b8b8b8;\n  /* transform: scale(1);  */\n  /* padding: 5px;  */\n}\n\n.pagination-controls button:active:not(:disabled) {\n  /* color: #004080;  */\n  color: #b8b8b8;\n  /* transform: scale(1);  */\n}\n\n.chart-header {\n  position: relative;\n  text-align: center;\n  margin-bottom: 2px;\n}\n\n.export-csv-button {\n  position: absolute;\n  right: 0; /* Align to the right side */\n  top: 50%;\n  transform: translateY(-50%); /* Center vertically */\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n}\n\n.export-csv-button i {\n  margin-right: 5px;\n  font-size: 14px;\n}\n\n\n/*Map */\n.custom-map-tooltip {\n  position: absolute;\n  text-align: center;\n  color: white;\n  width: auto;\n  height: auto;\n  padding: 5px;\n  font: 12px sans-serif;\n  background: black !important;\n  border: 1px solid black !important;\n  border-radius: 8px;\n  pointer-events: none;\n}\n\n.custom-triangle-marker div {\n  width: 0;\n  height: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-bottom: 20px solid red; /* Default color for the triangle */\n  position: relative;\n  top: -10px; /* Adjusts the triangle position */\n}\n\n.filter-content {\n  /* z-index: 1000000000 !important; */\n  /* top: 65px; */\n  /* width: 13rem; */\n  right: 19px;\n  height: 100%;\n  width: 24rem;\n  background-color: white;\n  box-shadow: -5px 0px 7px 0px rgba(223, 224, 225, 0.2);\n  transform: translateX(100%);\n  transition: transform 0.3s ease-in-out;\n  height: 83vh;\n  position: fixed;\n}\n\n.DarkTheme .filter-content {\n  background-color: var(\n    --foundation-neutral-dark-theme-neutral-dark-theme-500,\n    #494b4b\n  );\n}\n\n.DarkTheme .dark-heading {\n  color: black !important;\n}\n\n.filter-content.open {\n  transform: translateX(0);\n}\n\n.button-toggle-filter {\n  margin-left: -2rem;\n  position: absolute;\n  z-index: 1000000000000;\n  margin-top: -2rem;\n}\n\n.content-view-filters {\n  height: 100vh;\n  padding: 20px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.filter-popup {\n  position: absolute;\n  width: 100%;\n  top: 10%;\n  left: 0;\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n}\n\n.filter-popup-content {\n  z-index: 1000;\n}\n\n.overlay-filter-popup {\n  position: fixed;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 9;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.disabled-filter-content {\n  pointer-events: none;\n  opacity: 0.5;\n}\n\n.filter-top-container-bottom-border {\n  margin-top: 10px;\n  margin-bottom: 10px;\n  border-bottom: 1px solid var(--primary);\n  box-shadow: 0 4px 2px -2px var(--secondary-100);\n}\n\n/* Select control (dropdown input) */\n.custom-select__control {\n  border: 2px solid var(--primary) !important;\n  box-shadow: none !important;\n  border-radius: 12px !important;\n}\n\n.custom-select__control:hover {\n  border-color: #888;\n}\n\n/* Select menu (dropdown list) */\n.custom-select__menu {\n  border: 1px solid var(--primary);\n  width: 200px; /* Adjust if needed */\n  border-radius: 12px !important;\n  font-size: 14px !important;\n}\n\n/* Highlight on hover */\n.custom-select__option--is-focused {\n  background-color: #f0f0f0;\n}\n\n/* Selected option */\n.custom-select__option--is-selected {\n  background-color: #ccc;\n}\n\n/* Apply ellipsis to the options that exceed the width */\n.custom-select__option {\n  white-space: nowrap; \n  overflow: hidden; \n  text-overflow: ellipsis; \n  max-width: 100%; \n  position: relative; \n}\n\n/* Show full option name in a tooltip on hover */\n.custom-select__option:hover::after {\n  content: attr(data-tooltip); \n  position: absolute;\n  left: 100%; \n  top: 0;\n  white-space: nowrap;\n  background-color: #333;\n  color: #fff;\n  padding: 5px;\n  border-radius: 3px;\n  z-index: 10;\n  font-size: 12px;\n  display: inline-block;\n  opacity: 1;\n  visibility: visible;\n}\n\n/* Make sure the tooltip is hidden by default */\n.custom-select__option::after {\n  content: \"\";\n  display: none;\n  opacity: 0;\n  visibility: hidden;\n}\n\n.custom-option {\n  white-space: nowrap; \n  overflow: hidden; \n  text-overflow: ellipsis; \n  max-width: 100%; \n  display: block; \n}\n\n.overlay-filter-save-popup {\n  position: fixed;\n  top: 0;\n  z-index: 20000000000 !important;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: var(--foundation-neutral-neutral-900, #5c6065c1);\n  width: 100%;\n  height: 107%;\n  display: flex;\n  justify-content: center;\n  .taskPopUp,\n  .memberPopup,\n  .modalPopup {\n    margin-top: 80px;\n    background: white;\n    overflow-x: hidden;\n    max-height: fit-content;\n    min-width: 95%;\n    &.h-auto {\n      height: auto !important;\n      min-height: auto;\n    }\n    .scrollable {\n      max-height: 65vh;\n      overflow-y: auto;\n      scroll-behavior: smooth;\n      height: -webkit-fill-available;\n    }\n    .title {\n      overflow: hidden;\n      color: var(--text-high-emphasis, #090826);\n      text-overflow: ellipsis;\n\n      /* Typography/Heading 3/Bold */\n      font-family: Inter;\n      font-size: 1.8rem;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 120%; /* 42px */\n    }\n    .title-text-small-color {\n      color: var(--text-high-emphasis, #090826);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
